import { render, staticRenderFns } from "./addSourceOfFunding.vue?vue&type=template&id=66a4e5f6&scoped=true"
import script from "./addSourceOfFunding.vue?vue&type=script&lang=js"
export * from "./addSourceOfFunding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a4e5f6",
  null
  
)

export default component.exports